import React from "react";
import { Link } from "react-router-dom";
import friend from '../../assest/image/Friends.png';
function InvestRealState1() {
  document.title = "SimWealth";
  return (
    <>
      <div className="bg bg-InvestRealState1">
      <div data-aos="fade-left" className="container-fluid  row  vh-100 w-100">
            <div className="col-sm-6 d-flex align-items-end justify-content-end my-auto text-center ">
                <div className="bg-white rounded-border p-4 border border-4 border-dark">
                  <p className="py-1">Meet Dave and Sam, lifelong buddies with a shared passion for real estate investing.</p>
                  <p className="py-1">They started with the same amount of capital and purchased two side-by-side identical rental properties.</p>
                   <p className="py-1">The driving force behind this investment is a universal aspiration: to provide for their families.</p>
                   <p className="py-1">It's a tale of dreams, friendship, and the unwavering commitment to making those dreams come true.</p>
                  <Link to={'/investing-in-real-estate/second-step'} className=" threeDButton btn fw-bold  w-50  ">Continue</Link>
                </div>
            </div>
           <div className="col-sm-6 d-flex align-items-center justify-content-center position-relative">
              <Link to={'/choose-a-simulation'} className=" threeDButton btn fw-bold RightBtn ">MainMenu</Link>
               <img src={friend} className="frndImage" alt="friend" />
           </div>
        </div>
      </div>
    </>
  );
}

export default InvestRealState1;
